import { ApiService } from '../services/ApiService';
import { Router } from '../router/Router';
import { StepBar } from './StepBar';
import { Header } from './Header';

/**
* Component Model.
*/
export class Component {
  /**
  * Constructor of the Component.
  *
  * @param   {string}  container - Container.
  */
  constructor(container) {
    this.container = container;
    this.resizeEvent = document.createEvent('HTMLEvents');
    this.resizeEvent.initEvent('resize', true, false);
  }

  /**
  * Render the component.
  *
  * @param {object} opts - The options to render the component.
  */
  render(opts) {
    const container = document.querySelector(this.container);
    const stage = opts && opts.stage;
    const view = opts && opts.view;

    // If the stage is set in options, set the route of the component when rendering
    if (stage) {
      Router.setRoute(stage);
      StepBar.render(opts);
    }

    // If the view is set in options and the container exist, set the view in this container
    if (view && container) {
      document.querySelector(this.container).innerHTML = view;
    }

    Header.initBackListener();
    window.dispatchEvent(this.resizeEvent);
  }

  /**
  * Hide the component in the container.
  */
  hide() {
    document.querySelector(this.container).style.visibility = 'hidden';
  }

  /**
  * Show the component in the container.
  */
  show() {
    document.querySelector(this.container).style.visibility = 'visible';
  }

  /**
  * Request the signup API and submit the data of the user civility.
  *
  * @param   {object}  options - Body to request.
  * @param   {boolean} isBack - Boolean if back button pressed.
  * @param   {boolean} fromCaptcha - Boolean if called from Captcha view.
  * @returns {Promise} Resolved promise to chain next process.
  */
  static makeRequest(options, isBack, fromCaptcha) {
    if (!ApiService.requestPending) {
      return new Promise((resolve, reject) => {
        ApiService.makeRequest({
          url: options.url,
          method: options.method,
          body: options.data,
        })
          .then((response) => {
            // Set data
            const { data } = response;

            // Set is back
            if (data) {
              data.isBack = isBack;
              data.fromCaptcha = fromCaptcha;
            }

            Router.insertStage(data);

            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    }
  }

  /**
   * Tell the visually impaired that the page has changed.
   */
  announceNextPageLoad() {
    const stepTitle = document.querySelector('#stepTitlePage');

    if (stepTitle !== null) {
      stepTitle.focus();
    }
  }

  /**
   * Call o_audience function from Common Elements to update pageview.
   *
   * @param {object} trackingObj - Tagging Object.
   */
  static updateTracking(trackingObj) {
    if (typeof window.o_audience === 'function') {
      window.o_audience(trackingObj);
    }
  }
}
